import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-text",
  "use": "icon-nav-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav-text\">\r\n  <path d=\"M24.380952 560.761905h97.52381v-58.514286h112.152381v438.857143h97.523809v-438.857143H438.857143v58.514286h97.523809V404.72381H24.380952z\" p-id=\"13358\" />\r\n  <path d=\"M273.066667 78.019048v175.542857h97.523809V175.542857H585.142857v770.438095h97.52381V175.542857h219.428571v82.895238h97.52381V78.019048z\" p-id=\"13359\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol